import { useContext } from 'react'
import { AuthContext } from './AuthProvider'

export function useAdminAuth() {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAdminAuth must be used within an AuthProvider')
  }
  return context
}

/**
 * Checks if the user has the required Keycloak realm role.
 * Token structure: { realm_access: { roles: ['platform-operator', ...] } }
 */
export function useHasRole(role: string): boolean {
  const { user } = useAdminAuth()
  if (!user?.profile) return false

  const realmAccess = (user.profile as Record<string, unknown>).realm_access as
    | { roles?: string[] }
    | undefined
  return realmAccess?.roles?.includes(role) ?? false
}
